import React from 'react';
import Text from 'components/Core/Text';
import HyperLink from 'components/Core/HyperLink';
import icon from './images/sign-in-icon.svg';
import iconWhite from './images/sign-in-icon-white.svg';
import Banner from '..';
import { Container } from './styles';

const AnnouncementBar = ({ copy, hideSignIn, linkTitle, linkUrl, theme }) => {
  const darkTheme = theme === 'TRANS_BG_BLACK_COLOR' || theme === 'WHITE_BG_BLACK_COLOR';

  return (
    <Banner className="website-header--announcement-bar min-xl">
      <Container isBlack={darkTheme}>
        <Text type="p" size="normal">
          {copy || 'Discover your ROI with ServiceTitan'}
          {': '}
          <HyperLink
            href={linkUrl || '/tools/roi-calculator'}
            ctaPosition="announcementbar roi calculator"
            className="announcement-bar--link"
          >
            {linkTitle || 'Calculate Here'}
          </HyperLink>
        </Text>
        {!hideSignIn && (
          <div className="announcement-bar--sign-in gap-[10px]">
            <Text type="p" size="normal">
              <HyperLink
                href="https://www.servicetitan.com/customer-resource-hub"
                ctaPosition="customer resource hub"
              >
                <strong>Customer Resource Hub</strong>
              </HyperLink>
            </Text>
            <div className={`divider h-[27px] w-[2px] ${darkTheme ? 'bg-black' : 'bg-white'}`} />
            <Text type="p" size="normal">
              <HyperLink
                href="https://go.servicetitan.com/auth/externallogin"
                ctaPosition="announcementbar signin"
                target="_blank"
              >
                <strong>Sign in</strong>
                <img src={iconWhite} alt="" className="announcement-bar--icon white-icon" />
                <img src={icon} alt="" className="announcement-bar--icon tertiary-icon" />
              </HyperLink>
            </Text>
          </div>
        )}
      </Container>
    </Banner>
  );
};

export default AnnouncementBar;
